import { render, staticRenderFns } from "./BarChartViewer.vue?vue&type=template&id=6ce2b65d&scoped=true&"
import script from "./BarChartViewer.vue?vue&type=script&lang=js&"
export * from "./BarChartViewer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ce2b65d",
  null
  
)

export default component.exports